// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4fknX","field":"styles_field__JsM9Y","fieldCol":"styles_fieldCol__3HFtI","diffCol":"styles_diffCol__1ErBZ","diff":"styles_diff__-F27J"};